import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_MAP_MARKER](state, p) {
    const drp = p.drp;
    drp.map.markers.splice(0, 0, p.marker);
  },
  [types.REMOVE_MAP_MARKER](state, p) {
    const drp = p.drp;
    drp.map.markers.splice(p.index, 1);
  },
  [types.SET_MAP_MARKER_TITLE](state, p) {
    const drp = p.drp;
    drp.map.markers[p.index].title = p.title;
  },
  [types.SET_MAP_MARKER_ADDRESS](state, p) {
    const drp = p.drp;
    drp.map.markers[p.index].address = p.address;
    drp.map.markers[p.index].lat = p.lat;
    drp.map.markers[p.index].lng = p.lng;
  },
  [types.SET_MAP_MARKER_IMG](state, p) {
    const drp = p.drp;
    drp.map.markers[p.index].markerImg = p.markerImg;
  },
};

const actions = {
  addMapMarker: ({ commit }, payload) => {
    commit(types.ADD_MAP_MARKER, payload);
  },
  removeMapMarker: ({ commit }, payload) => {
    commit(types.REMOVE_MAP_MARKER, payload);
  },
  setMapMarkerTitle: ({ commit }, payload) => {
    commit(types.SET_MAP_MARKER_TITLE, payload);
  },
  setMapMarkerAddress: ({ commit }, payload) => {
    commit(types.SET_MAP_MARKER_ADDRESS, payload);
  },
  setMapMarkerImg: ({ commit }, payload) => {
    commit(types.SET_MAP_MARKER_IMG, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/google-map/vuex.js